export default {
  step1Title: "Tell Us About Your Business",
  step1Desc: "We'll use the industry type to customize calculations and recommendations for you.",
  step2Title: "Capacity and Operations",
  step2Desc: "Help us understand your daily booking volume and service value.",
  step3Title: "No-Shows, Cancellations & Missed Calls",
  step3Desc: "Enter your estimates for no-shows, cancellations, and the impact of missed calls.",
  step4Title: "Appointment Distribution & Peak Times",
  step4Desc: "Analyze peak times and lost customers due to poor distribution or lack of immediate availability.",
  step5Title: "Leaves and Downtimes",
  step5Desc: "Calculate the impact of annual or emergency downtimes on bookings and customer awareness.",
  step: "Step",
  of: "of",
  serviceCategoryLabel: "Main Service Category",
  catMedical: "Medical & Health",
  catEducation: "Education & Training",
  catProfessional: "Consulting & Pro Services",
  catField: "Field & Maintenance",
  catRental: "Rental & Spaces",
  catLifestyle: "Beauty & Lifestyle",
  serviceCategoryHelper: "Choose the category closest to your business to see relevant sub-services.",
  serviceTypeLabel: "Sub-Service Type",
  serviceTypeHelper: "Options filtered based on the main category.",
  currencyLabel: "Currency",
  deliveryModeLabel: "Service Delivery Mode",
  modeCenter: "At Center/Branch",
  modeOnline: "Online",
  modeClient: "At Client Location",
  deliveryModeHelper: "You can select more than one.",
  complexityLabel: "Do you have multiple branches or providers?",
  compNone: "No",
  compProviders: "Yes, multiple providers",
  compBranches: "Yes, multiple branches",
  compBoth: "Yes, branches and providers",
  dailyBookingsLabel: "Avg Daily Bookings",
  dailyBookingsHelper: "Average bookings actually completed daily.",
  avgValueLabel: "Avg Booking Value",
  avgValueHelper: "Approximate average value of a booking.",
  workingDaysLabel: "Working Days per Month",
  workingDaysHelper: "e.g. 26 working days.",
  avgDurationLabel: "Avg Booking Duration",
  minutes: "mins",
  avgDurationHelper: "Helps estimate daily capacity.",
  resourceCountLabel: "Number of Providers/Resources",
  resourceCountHelper: "Doctors, Trainers, Rooms...",
  workingHoursLabel: "Daily Working Hours",
  workingHoursHelper: "To estimate maximum daily capacity.",
  expectedRevenue: "Expected Revenue from Bookings",
  noShowRateLabel: "No-Show Rate",
  cancelRateLabel: "Cancellation Rate",
  compensatedCancelRateLabel: "Compensated Cancel Rate",
  missedCallsLabel: "Missed Calls per Day",
  callConversionRateLabel: "Call Conversion Rate",
  step4Info: "Sometimes the problem is poor distribution.",
  peakLostBookingsLabel: "Lost Bookings at Peak Times (Daily)?",
  redistributionRateLabel: "Redistribution Rate (to other times)",
  idleTimesLabel: "Do you have clear idle times?",
  idleDaily: "Yes, daily",
  idleSometimes: "Sometimes",
  idleRarely: "Rarely",
  idleUnknown: "I don't know",
  step5Info: "Downtimes aren't calculated as a loss if known in advance.",
  annualLeaveDaysLabel: "Annual Leave Days",
  officialHolidayDaysLabel: "Official Holidays",
  eventDaysLabel: "Event Days",
  emergencyDaysLabel: "Emergency Downtime",
  affectedOppLabel: "Affected Opportunities per Downtime Day",
  communicationLevelLabel: "Notify customers of downtime?",
  commClear: "Yes, clearly",
  commSometimes: "Sometimes",
  commNo: "No",
  commNone: "No system",
  availabilityAlternativeRateLabel: "Conversion Rate to Alt Time",
  totalUnavailableDays: "Total Annual Downtime Days",
  days: "Days",
  prev: "Previous",
  next: "Next",
  showResults: "Show Results",
  liveSummary: "Live Summary",
  expectedMonthlyBookings: "Expected Monthly Bookings",
  booking: "Booking",
  monthlyLoss: "Monthly Unutilized Opportunities",
  avgUnavailableDays: "Avg Monthly Downtime",
  resultTitle: "Your Estimated Result",
  resultDesc: "Based on the data provided, these are rough estimates of revenue that could be lost due to booking management issues.",
  totalMonthlyLoss: "Total Monthly Unutilized Opps",
  potentialEst: "Potential Estimate",
  confirmedLosses: "Confirmed Booking Losses",
  noShowAndCancel: "No-show + Uncompensated Cancels",
  growthOpportunities: "Lost Growth Opportunities",
  outsideRevenue: "Opps Outside Current Revenue",
  recoverableRevenue: "Partially Recoverable Revenue",
  notFullyGuaranteed: "Not Fully Guaranteed",
  annualPotentialValue: "Annual Potential Value",
  monthlyLossBookings: "Monthly Unutilized Opps",
  dailyCapacity: "Daily Capacity",
  annualAvailabilityLoss: "Annual Downtime Impact",
  totalUnavailableDaysAnnual: "Annual Downtime Days",
  lossBreakdownTitle: "Breakdown of Unutilized Opps",
  category: "Category",
  source: "Source",
  monthlyOpportunities: "Monthly Opps",
  monthlyValue: "Monthly Value",
  lossComparisonTitle: "Comparison of Loss Sources",
  riskIndicatorsTitle: "Operational Risk Indicators",
  confirmedRiskPercent: "Confirmed Unutilized Opps",
  confirmedRiskDesc: "Measures the impact of no-shows and uncompensated cancellations on current revenue.",
  growthRiskPercent: "Lost Growth Opportunities",
  growthRiskDesc: "Measures the value of opportunities that didn't turn into bookings compared to current revenue.",
  riskDisclaimer: "These figures are estimates intended to identify areas for improvement.",
  biggestSourceBadge: "Biggest Source of Unutilized Opps",
  yourMainProblem: "Your Main Problem",
  exportPdf: "Export PDF Report",
  requestRecsBtn: "Request Recommendations",
  ctaTitle: "Turn Lost Bookings into Actual Revenue",
  ctaDesc: "SplendApp's booking app helps you organize appointments and reduce no-shows.",
  talkToConsultant: "Talk to a Consultant",
  feat1: "Direct App Booking",
  feat2: "Automated Reminders",
  feat3: "Cancellation Management",
  feat4: "Better Appointment Dist",
  feat5: "Dashboard",
  feat6: "Packages & Subs",
  leadTitle: "Request Recommendations & Solutions",
  leadDesc: "Enter your details to receive the general recommendations file in your email.",
  name: "Name",
  nameHolder: "Enter your name",
  businessName: "Business Name",
  businessNameHolder: "e.g. Al Noor Clinic",
  whatsapp: "WhatsApp Number",
  email: "Email Address",
  country: "Country",
  timeline: "When to start?",
  submitLead: "Request Recommendations",
  downloadGeneralPdf: "Download General PDF Recommendations",
  leadSuccessDemo: "Successful process. Lead Score: ",
  leadSuccessReal: "Your request was received successfully!",
  leadError: "Sorry, Error: "
};
